import { createSlice } from '@reduxjs/toolkit';

const initialState = { loading: false };
const loadSlice = createSlice({
  name: 'load',
  initialState,
  reducers: {
    enableLoading: (state, action) => {
      state.loading = action.payload;
    },
    disableLoading: (state, action) => {
      state.loading = action.payload;
    },
  },
});

const { reducer, actions } = loadSlice;
export const { enableLoading, disableLoading } = actions;
export default reducer;
